<div>  
  <app-lista-dados
    [upTitulo]="'Lista de Padrões de Importação'"
    [upIcone]="'settings'"
    [upCor]="'3f51b5'"
    [upDados]="padroes"
    [upColunas]="colunasListaDados"
    [upHabilitaEditarLinha]="true"
    [upLargura]="2"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    [upCarregando]="!!subscription"
    (ueBotaoExcluir)="onDelete($event)"
    (ueSalvarLinha)="onSalvarLinha($event)">
  </app-lista-dados>
</div>
